import workSheet from '../../services/workSheet.service';
import user from '../../services/user.service';
// import { createNamespacedHelpers } from "vuex";
// const { Auth } = createNamespacedHelpers("Auth");
export default {
    namespaced: true,
    state: {
        selectedUser: null,
        loggedInUser: {
            name: 'Monisha A',
            id: '6389e03e33550818d96b2e4f',
            designation: 'SENIOR_SOFTWARE_DEVELOPER',
            role: 'ADMIN',
        },
        userList: [],
        employeeList: [],
        assigneeList: [],
        totalUserList: 0,
        workSheetList: [],
        currentWorkSheet: null,
        allWorkSheet: [],
        currentUserWorkSheet: [],
        activeTask: {},
        activeDay: {},
        history: [],
        historyList: [],
        progress: {},
        heatmapdata: [],
        graphData: [],
        locationOption: [],
        teamOption: [],
        designationOption: [],
        managerOption: [],
        reporteeList: [],
    },
    getters: {
        getUserList(state) {
            return state.userList;
        },
        getAssigneeList(state) {
            return state.assigneeList;
        },
        getUserListOption(state) {
            return state.userList.map((user) => {
                return {
                    value: user.id,
                    label: user.name,
                };
            });
        },
        getUserListOptionForBulkAssign(state) {
            return state.employeeList.map((user) => {
                return {
                    id: user.id,
                    name: user.name,
                };
            });
        },
        getEmployeeListOptionForBulkAssign(state) {
            return state.employeeList.map((user) => {
                return {
                    id: user.id,
                    name: user.name,
                };
            });
        },
        getTotalUserListCount(state) {
            return state.totalUserList;
        },
        getSelectedUser(state) {
            return state.selectedUser;
        },
        getWorkSheetList(state) {
            return state.workSheetList;
        },
        getCurrentUserWorkSheetList(state) {
            return state.currentUserWorkSheet;
        },
        getActiveTask(state) {
            return state.activeTask;
        },
        getActiveDay(state) {
            return state.activeDay;
        },
        getHistory(state) {
            return state.history.slice(0, 15);
        },
        getHistoryList(state) {
            return state.historyList.reverse().slice(0, 15);
        },
        getProgress(state) {
            return state.progress;
        },
        getHeatMapData(state) {
            return state.heatmapdata;
        },
        getAllWorkSheet(state) {
            return state.allWorkSheet;
        },
        getWorkSheetOption(state) {
            return state.allWorkSheet?.map((worksheet) => {
                return {
                    label: worksheet.name,
                    value: worksheet.id,
                };
            });
        },
        getGraphData(state) {
            // let tasks= state.graphData.map((data)=>{
            //   return data.totalCompletedTask.toString()
            // });
            // let days= state.graphData.map((data)=>{
            //   return data.date.toString()
            // });
            // return [tasks,days]
            return state.graphData.map((data) => {
                return { x: new Date(data.date).getTime(), y: data.totalCompletedTask };
            });
        },
        getCurrentWorkSheet(state) {
            return state.currentWorkSheet;
        },
        getLocationOption(state) {
            let constructedLocationOption = state.locationOption.map((data) => {
                return {
                    value: data.id,
                    label: data.city,
                };
            });
            return constructedLocationOption;
        },
        getTeamOption(state) {
            let constructedTeamOption = state.teamOption.map((data) => {
                return {
                    value: data.id,
                    label: data.name,
                };
            });
            return constructedTeamOption;
        },
        getReporteeList(state) {
            return state.reporteeList;
        },
        getDesignationOption(state) {
            let constructedDesignationOption = state.designationOption.map((data) => {
                return {
                    value: data.id,
                    label: data.designation.replaceAll('_', ' '),
                };
            });
            return constructedDesignationOption;
        },
        getManagerOption(state) {
            let constructedManagerOption = state.managerOption.map((data) => {
                return {
                    value: data.id,
                    label: data.name,
                };
            });
            return constructedManagerOption;
        },
    },
    mutations: {
        setUserList(state, payload) {
            state.userList = payload;
        },
        setEmployeeList(state, payload) {
            state.employeeList = payload;
        },
        setAssigneeList(state, payload) {
            state.assigneeList = payload;
            if (state.loggedInUser.role === 'ASSIGNEE') state.assigneeList.push(state.loggedInUser);
        },
        setSelectedUser(state, payload) {
            state.selectedUser = payload;
        },
        totalUserListPaging(state, payload) {
            state.totalUserList = payload;
        },
        setWorkSheetList(state, payload) {
            state.currentUserWorkSheet = payload;
            let count = 0;
            const constructedWorkSheet = payload
                .map((day) => {
                    return (
                        day.taskList.length > 0 && {
                            day: 'DAY ' + ++count,
                            status: day.status,
                            taskList: day.taskList.map((task) => {
                                return {
                                    completedDate: task.completedDate ?? new Date(),
                                    link: '',
                                    id: task.task?.id,
                                    title: task.task?.title,
                                    status: task.status ?? false,
                                };
                            }),
                        }
                    );
                })
                .filter(Boolean);

            state.workSheetList = constructedWorkSheet;
        },
        addDayToWorkSheet(state, payload) {
            state.workSheetList.push(payload);
        },
        removeDayFromWorkSheet(state, payload) {
            state.workSheetList.splice(payload, 1);
        },
        validateWorkSheet(state, { constructedTaskList, index }) {
            state.workSheetList[index].taskList = constructedTaskList;
        },
        removeTaskFromTaskList(state, { worksheetIndex, taskId }) {
            let task = state.workSheetList[worksheetIndex].taskList.findIndex((task) => task.id == taskId);
            state.workSheetList[worksheetIndex].taskList.splice(task, 1);
        },
        setActiveTask(state, task) {
            state.activeTask = task;
        },
        setActiveDay(state, day) {
            state.activeDay = day;
        },
        setHistory(state, data) {
            state.history = data;
        },
        setProgress(state, data) {
            state.progress = data;
        },

        setHistoryList(state, data) {
            state.historyList = data;
        },

        setHeatMapData(state, data) {
            state.heatmapdata = data.map((data) => {
                let temp = { date: data.date, count: data.totalCompletedTask };
                return temp;
            });
        },
        setAllWorkSheet(state, data) {
            state.allWorkSheet = data;
        },
        setGraphData(state, data) {
            state.graphData = data;
        },
        setCurrentWorkSheet(state, data) {
            state.currentWorkSheet = data;
        },
        setLocationOption(state, data) {
            state.locationOption = data;
        },
        setTeamOption(state, data) {
            state.teamOption = data;
        },
        setDesignationOption(state, data) {
            state.designationOption = data;
        },
        setManagerOption(state, data) {
            state.managerOption = data;
        },
        setReporteeList(state, data) {
            state.reporteeList = data;
        },
    },
    actions: {
        SET_SELECTED_USER({ commit }, payload) {
            commit('setSelectedUser', payload);
        },
        ADD_DAY_TO_WORKSHEET({ commit }, payload) {
            commit('addDayToWorkSheet', payload);
        },
        REMOVE_DAY_FROM_WORKSHEET({ commit }, payload) {
            commit('removeDayFromWorkSheet', payload);
        },
        VALIDATE_WORKSHEET({ commit }, payload) {
            commit('validateWorkSheet', payload);
        },
        REMOVE_TASK_FROM_TASKLIST({ commit }, payload) {
            commit('removeTaskFromTaskList', payload);
        },
        ASSIGN_WORK_SHEET(context, { payload, successCallback, errorCallback }) {
            workSheet.assignTask(
                // { worksheet: payload, userId: state.selectedUser.id },
                payload,
                {
                    success: (res) => {
                        successCallback && successCallback(res);
                    },
                    error: (err) => {
                        errorCallback && errorCallback(err);
                    },
                }
            );
        },
        BULK_ASSIGN_WORKSHEET(context, { payload, successCallback, errorCallback }) {
            workSheet.bulkAssignWorksheet(payload, {
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
        GET_WORKSHEET_BY_USER_ID({ commit }, id) {
            workSheet.getworkSheetByUserId(id, {
                success: ({ data }) => {
                    if (data.status === 'OK') {
                        commit('setWorkSheetList', data.data.worksheet);
                        commit('setCurrentWorkSheet', data.data.name);
                    } else {
                        commit('setWorkSheetList', []);
                    }
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        GET_EMPLOYEE_LIST({ commit }, { name = '', page = 1, size = 50 }) {
            user.getUserList(
                {
                    params: {
                        name,
                        page,
                        size,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setEmployeeList', data.data.content);
                    },
                    error: (err) => {
                        console.log(err);
                        console.clear();
                    },
                }
            );
        },
        GET_USER_LIST({ commit }, { name = '', page = 1, size = 10 }) {
            user.getUserList(
                {
                    params: {
                        name,
                        page,
                        size,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setUserList', data.data.content);
                        commit('totalUserListPaging', data.data.totalElements);
                    },
                    error: (err) => {
                        console.log(err);
                        console.clear();
                    },
                }
            );
        },
        GET_ASSIGNEE_LIST({ commit, state }, { name = 'a', size = 10, page = 1, designation }) {
            if (state.loggedInUser.role === 'ASSIGNEE') {
                user.getAssigneeList(
                    {
                        params: {
                            name,
                            page,
                            designation,
                        },
                    },
                    {
                        success: ({ data }) => {
                            commit('setAssigneeList', data.data.content);
                        },
                        error: (err) => {
                            console.log(err);
                            console.clear();
                        },
                    }
                );
            } else {
                user.getUserList(
                    {
                        params: {
                            name,
                            page,
                            size,
                        },
                    },
                    {
                        success: ({ data }) => {
                            commit('setAssigneeList', data.data.content);
                        },
                        error: (err) => {
                            console.log(err);
                            console.clear();
                        },
                    }
                );
            }
        },
        SET_ACTIVE_TASK({ commit }, task) {
            commit('setActiveTask', task);
        },
        SET_ACTIVE_DAY({ commit }, day) {
            commit('setActiveDay', day);
        },
        UPDATE_TASK_STATUS(context, { taskData, successcallback, errorcallback }) {
            user.updateTaskStatus(taskData, {
                success: (res) => {
                    successcallback && successcallback(res);
                },
                error: (err) => {
                    errorcallback && errorcallback(err);
                },
            });
        },
        GET_HISTORY_BY_ID({ commit }, id) {
            user.getHistoryById(id, {
                success: ({ data }) => {
                    commit('setHistory', data.data);
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        GET_PROGRESS_BY_ID({ commit }, id) {
            workSheet.getProgressById(id, {
                success: ({ data }) => {
                    commit('setProgress', data.data);
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        GET_ALL_HISTORY({ commit }) {
            user.getAllHistory({
                success: ({ data }) => {
                    commit('setHistoryList', data.data);
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },

        GET_HEAT_MAP_DATA({ commit }, id) {
            workSheet.getHeatMapDataById(id, {
                success: ({ data }) => {
                    commit('setHeatMapData', data.data);
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        CREATE_EMPLOYEE(context, { payload, successCallback, errorCallback }) {
            user.createUser(payload, {
                success: (response) => {
                    successCallback && successCallback(response);
                },
                error: (error) => {
                    errorCallback && errorCallback(error);
                },
            });
        },
        GET_ALL_WORKSHEET({ commit }, id) {
            user.getAllWorkSheet(id, {
                success: ({ data }) => {
                    if (data.status === 'OK') {
                        commit('setAllWorkSheet', data.data.moduleDetails || []);
                        commit('setSelectedUser', data.data.user);
                    } else {
                        commit('setAllWorkSheet', []);
                        commit('setSelectedUser', null);
                    }
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        RESET_CURRENT_WORKSHEET({ commit }) {
            commit('setCurrentWorkSheet', '');
        },
        GET_GRAPH_DATA_BY_ID({ commit }, id) {
            workSheet.getGraphDataById(id, {
                success: ({ data }) => {
                    if (data.data != null) commit('setGraphData', data.data);
                    else {
                        commit('setGraphData', []);
                    }
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        CREATE_WORKSHEET(context, { payload, successCallback, errorCallback }) {
            workSheet.createWorkSheet(payload, {
                success: (response) => {
                    successCallback && successCallback(response);
                },
                error: (error) => {
                    errorCallback && errorCallback(error);
                },
            });
        },
        GET_EMPLOYEE_BY_MANAGER_ID({ commit }, { id, size = 100, page = 1, name = '' }) {
            user.getEmployeeByManagerId(
                id,
                {
                    params: {
                        size,
                        page,
                        name,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setReporteeList', data.data.content);
                    },
                    error: (err) => {
                        console.log(err);
                        console.clear();
                    },
                }
            );
        },
        GET_LOCATION_OPTION({ commit }) {
            user.getLocationOption({
                success: ({ data }) => {
                    commit('setLocationOption', data.data);
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        GET_TEAM_OPTION({ commit }) {
            user.getTeamOption({
                success: ({ data }) => {
                    commit('setTeamOption', data.data);
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        GET_DESIGNATION_OPTION({ commit }, { designation = '' }) {
            user.getDesignationOption(
                {
                    params: {
                        designation,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setDesignationOption', data.data);
                    },
                    error: (err) => {
                        console.log(err);
                        console.clear();
                    },
                }
            );
        },
        GET_MANAGER_OPTION({ commit }, { name = '', page = 1, size = 20 }) {
            user.getManagerOption(
                {
                    params: {
                        name,
                        page,
                        size,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setManagerOption', data.data);
                    },
                    error: (err) => {
                        console.log(err);
                        console.clear();
                    },
                }
            );
        },
        UPDATE_PASSWORD(context,{payload,successcallback,errorcallback}){
            console.log(payload)
            user.updateUserPassword(payload,{
                success:(res)=>{
                    console.log("inside success")
                    successcallback && successcallback(res)
                },
                error:(err) =>{
                    console.log("inside error")
                    errorcallback && errorcallback(err)
                }
            })
        }
    },
};
